import React, { useEffect, useState } from "react";
import Style from "../style/bloglandingright.module.scss";
import { useAppDispatch } from "../redux/hooks";
import { fetchListing } from "../redux/Slice";
import { getProductsFromDB, saveProductsToDB } from "../indexDb/productDb";

interface IType {
  categories: any;
  recent_blogs: any;
  details: any;
}

const BlogLandingRight: React.FC<IType> = ({
  categories,
  recent_blogs,
  details,
}) => {
  const dispatch = useAppDispatch();
  const [listing, setListing] = useState<any[]>([]);
  const [search, setSearch] = useState("");
  const baseUrl = "https://backend.onedialusa.com/assets/img/blogs/";
  const baseUrl1 = "https://backend.onedialusa.com/assets/img/listing/";

  const handleSearch = () => {
    window.location.href = `/blog/category/${search
      .toLowerCase()
      .replaceAll(" ", "-")}`;
  };

  useEffect(() => {
    const loadListingData = async () => {
      const dbData = await getProductsFromDB();
      if (dbData.length > 0) {
        dispatch({
          type: "detail/setListingData",
          payload: { listings: dbData },
        });
        setListing(dbData);
      } else {
        const result = await dispatch(fetchListing());
        if (result?.payload?.listings) {
          saveProductsToDB(result.payload.listings);
          setListing(result.payload.listings);
        }
      }
    };

    loadListingData();
  }, [dispatch]);

  const categoryName = details?.categoryName || "Category not found";
  const filterListing = listing.filter(
    (item) => item.category_name === categoryName
  );

  return (
    <div className={Style.rightAside}>
      <div className={Style.searchBox}>
        <input
          type="text"
          placeholder="Search categories..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button onClick={handleSearch}>
          <i className="fas fa-search"></i>
        </button>
      </div>
      <div className={Style.section}>
        <h3>Recent Blogs</h3>
        <ul className={Style.recentBlogs}>
          {recent_blogs.map((blog: any) => (
            <li key={blog.id}>
              <a href={`/blog/${blog.slug}`}>
                <span>
                  <img
                    loading="lazy"
                    src={baseUrl + blog.image}
                    alt={blog.title}
                    width={100}
                    height={70}
                    onError={(e) => (e.currentTarget.src = "/fallback.jpg")}
                  />
                </span>
                <h2>{blog.title}</h2>
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className={Style.section}>
        <h3>Related Listings</h3>
        <ul className={Style.relatedList}>
          {filterListing &&
            filterListing.slice(0, 5).map((item: any) => (
              <li key={item.id}>
                <a href={`/listings/${item.slug}`}>
                  <span>
                    <img
                      loading="lazy"
                      src={baseUrl1 + item.feature_image}
                      alt={item.title}
                      width={100}
                      height={70}
                      onError={(e) => (e.currentTarget.src = "/fallback.jpg")}
                    />
                  </span>
                  <h2>{item.title}</h2>
                </a>
              </li>
            ))}
        </ul>
      </div>
      <div className={Style.section}>
        <h3>Categories</h3>
        <ul className={Style.categoryList}>
          {categories.map((cat: any) => (
            <li key={cat.id} className={Style.categoryItem}>
              <a href={`/blog/category/${cat.slug}`}>
                <i className="fas fa-tag"></i>
                <span>{cat.name}</span>
                <span className={Style.count}>({cat.blogCount})</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BlogLandingRight;
